import { lazy } from "react";

const StandardBlock = lazy(() => import("../../page/standard-block"));
const PrimaryBlock = lazy(() => import("../../page/primary-block"));
const VideoFeatureBlock = lazy(() => import("../../page/video-feature-block"));
const ListBlock = lazy(() => import("../list-block"));
const TableBlock = lazy(() => import("../table-block"));
const IntroBlock = lazy(() => import("../intro-block"));
const RelatedNewsBlock = lazy(() => import("./related-news-block"));
const FAQBlock = lazy(() => import("./faq-block"));
const CTABlock = lazy(() => import("./call-to-action-block"));
const TableauBlock = lazy(() => import("./tableau-block"));
const PersonVideoBlock = lazy(() =>
  import("../../academics/a-day-in-the-life-block")
);
const TextBlockImageRight = lazy(() =>
  import("../../academics/beyond-the-classroom-block")
);
const SimpleBlock = lazy(() => import("./simple-block"));

const PageBlock = ({ props }) => {
  const pageBlock = props;
  const map = new Map();
  map.set("standard", StandardBlock);
  map.set("primary", PrimaryBlock);
  map.set("videoFeature", VideoFeatureBlock);
  map.set("intro", IntroBlock);
  map.set("table", TableBlock);
  map.set("list", ListBlock);
  map.set("relatedNewsBlock", RelatedNewsBlock);
  map.set("faqBlock", FAQBlock);
  map.set("ctaBlock", CTABlock);
  map.set("tableau", TableauBlock);
  map.set("personVideoBlock", PersonVideoBlock);
  map.set("textBlockImageRight", TextBlockImageRight);
  map.set("textLeftPhotoRight", IntroBlock);
  map.set("titleLeftTextRight", IntroBlock);
  map.set("fullWidthText", SimpleBlock);
  map.set("standardWithMedia", StandardBlock);
  map.set("standardWithoutMedia", StandardBlock);

  const Component = map.get(pageBlock.pageBlockType);
  return Component === undefined ? (
    <p>Need to select a Block Type for none {pageBlock.title}</p>
  ) : (
    <Component pageBlock={pageBlock} />
  );
};

export default PageBlock;
